const chat = (users, currentUser) => {
    return {
        type: 'UPDATE',
        payload: { users, currentUser }
    }
}

export { chat }